<form (ngSubmit)="closeModal()" [formGroup]="form">
	<h1 mat-dialog-title>{{'persistInfoView.title' | translate}}</h1>
	<mat-dialog-content class="mat-dialog-content-no-scroll">
		<div fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
			<p>{{'persistInfoView.instructions' | translate}}</p>
			<app-toggle-all [checkboxesFormGroup]="form" [checkboxes]="checkboxes"></app-toggle-all>
			<mat-checkbox #checkbox *ngIf="data?.reference1" color="primary" formControlName="saveReference1">
				<strong>{{selectedCustomer?.captions?.referenceCaption ? selectedCustomer?.captions?.referenceCaption :
					('persistInfoView.referenceLabel' | translate)}}</strong> {{data?.reference1}}
			</mat-checkbox>
			<mat-checkbox #checkbox *ngIf="data?.reference2" color="primary" formControlName="saveReference2">
				<strong>{{selectedCustomer?.captions?.referenceCaption2 ? selectedCustomer?.captions?.referenceCaption2 :
					('persistInfoView.reference2Label' | translate)}}</strong> {{data?.reference2}}
			</mat-checkbox>
			<mat-checkbox #checkbox *ngIf="data?.serviceType" color="primary" formControlName="saveServiceType">
				<strong>{{selectedCustomer?.captions?.serviceTypeCaption ? selectedCustomer?.captions?.serviceTypeCaption :
					('persistInfoView.serviceTypeLabel' | translate)}}</strong> {{data?.serviceType}}
			</mat-checkbox>
			<mat-checkbox #checkbox *ngIf="!data?.parcels || data?.parcels?.length === 0" color="primary"
						  formControlName="savePieces">
				<strong>Pieces</strong> {{data?.pieces}}
			</mat-checkbox>
			<mat-checkbox #checkbox *ngIf="!data?.parcels || data?.parcels?.length === 0" color="primary"
						  formControlName="saveWeight">
				<strong>Weight</strong> {{data?.weight}}
			</mat-checkbox>
			<mat-checkbox #checkbox *ngIf="data?.parcels && data?.parcels?.length > 0" color="primary"
						  formControlName="saveParcels">
				<strong>{{'persistInfoView.parcelsLabel' | translate}}</strong> {{data?.parcels?.length}}
			</mat-checkbox>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions fxLayoutAlign="end">
		<button [color]="'accent'" mat-raised-button type="submit">
			{{'persistInfoView.continueButton' | translate}}
		</button>
	</mat-dialog-actions>
</form>
